import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';
import { includeQueryParamsForUrl, SletatMainPageSearchParamsUrlKeys } from 'sletat-common-utils/lib/getSletatSearchUrl';
import { FRONT_HOST_NAME, HOTEL_HOST_PHOTO_STORAGE, SLETAT_HOST_NAME_PUBLIC } from '../consts/hosts';
import { COUNTRY_SLIDE_IMAGE_URL } from '../consts/urls';
import { GetCountrySlideImageParams } from '../models/urls';


export {
    getSletatSearchUrl,
    SourceTypes,
} from 'sletat-common-utils/lib/getSletatSearchUrl';

export function getCountrySlideImageUrl(
    params: GetCountrySlideImageParams
): string {
    return `${COUNTRY_SLIDE_IMAGE_URL}?imageId=${params.imageId}&countryId=${params.countryId}&width=${params.width}&height=${params.height}`;
}

export function addVersionId(url: string): string {
    return canUseDOM ? includeQueryParamsForUrl(url, [SletatMainPageSearchParamsUrlKeys.FrontVersionId]) : url;
}

export function getToursUrl(country: string, resort?: string): string {
    return `https://${SLETAT_HOST_NAME_PUBLIC}/tours/${country}/${resort ?? ''}`;
}

export function getHotelsUrl(country: string, resort?: string): string {
    return `https://${SLETAT_HOST_NAME_PUBLIC}/hotels/${country}/${resort ?? ''}`;
}

export function getCheckoutUrlToBuy(
    sourceType: string,
    sourceId: number,
    offerId: number,
    requestId: number
): string {
    return addVersionId(
        `/checkout/${sourceId}-${offerId}-${requestId}/?source_type=${sourceType}`
    );
}

export function getFrontUrl(project: string, resource: string, hash?: string): string {
    return `https://${FRONT_HOST_NAME}/sletat/${project}/${isProd ? 'latest' : 'develop'}/${resource}${hash ? `?${hash}` : ''}`;
}

interface TransformURLPhotoParams {
    width: number;
    height: number;
  }

/**
 *
 * функция нужна преобразования ссылок на фото отоеле вида https://storage.yandexcloud.net/slt-hotels-room-storage/../.. к https://hotels-room.sletat.ru/../..
 */

export const transformURLHotelPhoto = (
    url: string,
    params: TransformURLPhotoParams,
  ) => {
    const search = new URLSearchParams();
    search.set('height', params.height.toString());
    search.set('width', params.width.toString());
    return `${url
      .replace('/slt-hotels-room-storage', '')
      .replace(
        'storage.yandexcloud.net',
        HOTEL_HOST_PHOTO_STORAGE,
      )}?${search.toString()}`;
  };
